import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Panel — базовая поверхность-контейнер без обязательной структуры (`.panel` макета):
 * граница + радиус из токенов, overflow-hidden для вложенных таблиц/списков. Без тени.
 */
export const Panel = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('ds-surface overflow-hidden rounded-12', className)} {...props} />
  ),
)
Panel.displayName = 'Panel'
